export const SAVE_SETTINGS = 'SAVE_SETTINGS'
export const GET_SETTINGS = 'GET_SETTINGS'